import { Component, inject, input } from '@angular/core'

import { AppConfigService } from 'app/app-config.service'

@Component({
  selector: 'app-empty-page',
  imports: [],
  templateUrl: './empty-page.component.html',
  styleUrl: './empty-page.component.scss'
})
export class EmptyPageComponent {
  message = input.required<string>()
  appConfigService = inject(AppConfigService)

  get storefrontId(): number | null {
    return this.appConfigService.getAppConfig.id
  }
}
